// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `noUiSlider`

import noUiSlider from 'nouislider/dist/nouislider.min';
window.noUiSlider = noUiSlider;
